import { useQueryClient } from "@tanstack/react-query"

export const taskTemplateKeys = {
  all() {
    return ["tasks-templates"] as const
  },

  taskTemplateLists() {
    return [...this.all(), "list"] as const
  },

  taskTemplateList(filters?: { limit: number; offset: number }) {
    if (!filters) {
      return [...this.taskTemplateLists()] as const
    }

    return [...this.taskTemplateLists(), filters] as const
  },
} as const

export function useTaskTemplateCache() {
  const queryClient = useQueryClient()

  function invalidateTaskTemplateList(filters?: {
    limit: number
    offset: number
  }) {
    const cacheKey = taskTemplateKeys.taskTemplateList(filters)

    return queryClient.invalidateQueries({
      queryKey: cacheKey,
    })
  }

  return {
    invalidateTaskTemplateList,
  }
}
